import script from "./TwoFactorChallenge.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorChallenge.vue?vue&type=style&index=0&id=3d762520&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d762520"]])

export default __exports__